<template>
  <v-container class="pt-0" fluid>
    <bulldozerr-wizard-tabs ref="WizardTab" :loading="loading" @save="save()" />
  </v-container>
</template>

<script>
  import pusherMixins from '@/mixins/pusherMixins';
  import BulldozerrService from '@/services/BulldozerrService';

  export default {
    components: {
      BulldozerrWizardTabs: () => import('@/components/bulldozerr/WizardTabs.vue')
    },

    mixins: [pusherMixins],

    data: () => ({
      loading: false
    }),

    methods: {
      save() {
        const data = this.$refs.WizardTab.saveData();

        this.loading = true;

        const postData = {
          nome: data.informacoesGerais.nome,
          parametros: JSON.stringify({
            data_inicial_analise: data.informacoesGerais.dataInicialAnalise,
            data_final_analise: data.informacoesGerais.dataFinalAnalise,
            id_empresa: data.informacoesGerais.empresaSelecionada,
            etapas: data.informacoesSelecaoEtapas.etapasSelecionadas,
            periodo_recuperacao: data.informacoesGerais.periodoRecuperacao,
            flg_fluxo_pagamento: data.informacoesBancoCompras?.fluxoPagamentoSelecionado ?? 0,
            vl_odc: data.informacoesBancoCompras?.valorOdc ?? 0,
            flg_imp_bdgd: data.informacoesBdgd?.flagImportarBdgd ?? 0,
            flg_imp_sdi: data.informacoesAis?.flagImportarAis ?? 0,
            flg_de_para: data.informacoesBaseIncremental?.checkboxRoaOuAis ?? 0,
            flg_dep_dia: data.informacoesBaseIncremental?.checkboxDepreciarDia ?? 0,
            flg_dep_mes: data.informacoesBaseIncremental?.checkboxDepreciarMes ?? 0,
            tx_amt_oe: data.informacoesObrigacoesEspeciais?.valorTaxaMediaSelecionado ?? 0,
            flg_legislacao: data.informacoesBancoCompras?.flagLegislacao ?? 0
          }),
          caminho_tmp: data.caminhoTmpUpload
        };

        BulldozerrService.save(postData)
          .then(() => {
            this.$toast.success('Analise BulldozeRR salva com sucesso.', '', {
              position: 'topRight'
            });
            this.$router.push({ name: 'Bulldozerr Histórico' });
          })
          .catch((err) => {
            console.error(err);
            this.$toast.error('Falha ao salvar o cálculo BulldozeRR', '', {
              position: 'topRight'
            });
          })
          .finally(() => (this.loading = false));
      }
    }
  };
</script>
